import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title"];
var IconArrowDown = function IconArrowDown(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-arrow-down"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.68 8.3a1 1 0 00-1.41 0l-5.28 5.28-5.26-5.27a1 1 0 00-1.4 0 1 1 0 000 1.41l5.96 5.99a1 1 0 001.41 0l5.98-6a1 1 0 000-1.42z"
  }));
};
IconArrowDown.displayName = 'InlineIcon(IconArrowDown)';
IconArrowDown.defaultProps = {
  title: null
};
IconArrowDown.propTypes = {
  title: PropTypes__default.string
};

export { IconArrowDown };
